import React from "react";
import { useTranslate } from "@pankod/refine-core";
import { Form, Input } from "@pankod/refine-antd";

interface Props {
  fieldName: number; // antd Form.List field.name (index into the levels array)
}

/**
 * Minigame config has no fixed schema yet (per backend plan §"Validación").
 * We bind a raw JSON textarea to `config_raw` (a helper key — not `config`)
 * to avoid antd seeing the same path as both string and object. The
 * thematicTransform serializer parses config_raw into a `config` object on
 * submit and the hydrator stringifies it back when populating edit forms.
 */
export const MinigameLevelConfig: React.FC<Props> = ({ fieldName }) => {
  const t = useTranslate();
  return (
    <Form.Item
      label={t("event.thematic.config_json")}
      name={[fieldName, "config_raw"]}
      rules={[
        {
          validator: (_r, v) => {
            if (!v) return Promise.resolve();
            try {
              JSON.parse(v);
              return Promise.resolve();
            } catch {
              return Promise.reject(
                new Error(t("event.thematic.config_json_invalid"))
              );
            }
          },
        },
      ]}
    >
      <Input.TextArea rows={6} placeholder='{ "id": 1, "time": 45 }' />
    </Form.Item>
  );
};
